import React, { useState } from "react";

const KEY = "ba-cookie-consent";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } };

function applyConsent(analytics, marketing) {
  localStorage.setItem(KEY, JSON.stringify({ choice: true, analytics, marketing, at: new Date().toISOString() }));
  if (window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: analytics ? "granted" : "denied",
      ad_storage: marketing ? "granted" : "denied",
      ad_user_data: marketing ? "granted" : "denied",
      ad_personalization: marketing ? "granted" : "denied",
    });
  }
}

const btn = "h-11 px-5 rounded-xl text-[13px] font-bold tracking-wide transition-opacity hover:opacity-90";

export const CookieBanner = () => {
  const [hidden, setHidden] = useState(() => !!read());
  const [prefs, setPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);
  if (hidden) return null;
  const decide = (a, m) => { applyConsent(a, m); setHidden(true); };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[70] p-3 sm:p-4" data-testid="cookie-banner" role="dialog" aria-label="Preferenze cookie">
      <div className="max-w-3xl mx-auto bg-[#0A192F] text-slate-200 rounded-2xl p-5 shadow-2xl border border-white/10">
        <p className="text-[13px] leading-relaxed">
          Questo sito utilizza cookie tecnici necessari al funzionamento e, solo con il tuo consenso, cookie di
          statistica e di marketing (Google). Puoi accettare, rifiutare o gestire le preferenze: la scelta viene
          salvata e puoi modificarla in qualsiasi momento cancellando i dati del sito.
        </p>
        {prefs && (
          <div className="mt-4 space-y-2" data-testid="cookie-prefs-panel">
            <label className="flex items-center gap-3 text-[13px] cursor-pointer">
              <input type="checkbox" checked disabled className="w-4 h-4 accent-[#B7955B]" />
              Cookie tecnici necessari (sempre attivi)
            </label>
            <label className="flex items-center gap-3 text-[13px] cursor-pointer">
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="w-4 h-4 accent-[#B7955B]" data-testid="cookie-pref-analytics" />
              Cookie di statistica (misurazione visite)
            </label>
            <label className="flex items-center gap-3 text-[13px] cursor-pointer">
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="w-4 h-4 accent-[#B7955B]" data-testid="cookie-pref-marketing" />
              Cookie di marketing (pubblicità Google)
            </label>
          </div>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          {prefs ? (
            <button onClick={() => decide(analytics, marketing)} className={`${btn} text-[#0A192F]`} style={{ background: "#B7955B" }} data-testid="cookie-save-prefs-btn">SALVA PREFERENZE</button>
          ) : (
            <>
              <button onClick={() => decide(true, true)} className={`${btn} text-[#0A192F]`} style={{ background: "#B7955B" }} data-testid="cookie-accept-btn">ACCETTA</button>
              <button onClick={() => decide(false, false)} className={`${btn} border border-slate-400 text-slate-200`} data-testid="cookie-reject-btn">RIFIUTA</button>
              <button onClick={() => setPrefs(true)} className={`${btn} underline underline-offset-4 text-slate-300`} data-testid="cookie-prefs-btn">GESTISCI PREFERENZE</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
